module.exports = __webpack_public_path__ + "static/media/YB5F10_2.36e9f306.jpg";